// extracted by mini-css-extract-plugin
export default {"component":"LeaderboardHeader_component__a69xR"};